// KAS Rewards Page JavaScript (external asset)

// Global configuration - check if already declared to avoid conflicts
if (typeof SHOP_DOMAIN === 'undefined') {
    var SHOP_DOMAIN = 'kas-australia.myshopify.com';
}
if (typeof LOYALTY_ENDPOINT === 'undefined') {
    var LOYALTY_ENDPOINT = 'https://data.kasaustralia.com.au/kas/points.php';
}
if (typeof LOYALTY_DETAILS_ENDPOINT === 'undefined') {
    var LOYALTY_DETAILS_ENDPOINT = 'https://data.kasaustralia.com.au/kas/customer.php';
}

document.addEventListener('DOMContentLoaded', function() {
    // Hook up rewards banner + drawer
    initRewardsBanner();
    // Fetch and display shop rules from Influence.io
    fetchShopRules();
    fetchRedeemRules();
    fetchLoyaltyTiers();
    fetchReferralRules();
    // Initialize customer tier status
    initCustomerTierStatus();
    // Initialize product points display
    initProductPointsDisplay();
    
    // Fetch customer loyalty details to get currentLoyaltyTierId
    if (window.customer?.id) {
        fetchCustomerLoyaltyDetails().then(function(loyaltyDetails) {
            if (loyaltyDetails && loyaltyDetails.currentLoyaltyTierId) {
                // Update the customer object with the tier ID
                window.customer.currentLoyaltyTierId = loyaltyDetails.currentLoyaltyTierId;
                
                // Re-calculate product points with the correct tier ID
                const productHelpers = document.querySelectorAll('.swell-product-helper[data-mode="display-points"]');
                productHelpers.forEach(function(helper) {
                    updateProductPoints(helper);
                });
                
                // Update customer points balance for redeem progress calculation
                if (loyaltyDetails.pointBalance !== undefined) {
                    window.customer.pointBalance = loyaltyDetails.pointBalance;
                    
                    // CRITICAL: Update the banner with the new points value
                    if (window.KASRewards && typeof window.KASRewards.updateBannerPoints === 'function') {
                        window.KASRewards.updateBannerPoints(loyaltyDetails.pointBalance);
                    }
                    
                    // CRITICAL: Update points UI and re-render redeem list if rules are already loaded
                    if (window.KASRewards && typeof window.KASRewards.updatePoints === 'function') {
                        window.KASRewards.updatePoints(loyaltyDetails.pointBalance);
                    } else {
                        // Fallback: manually trigger update
                        const redeemListContainer = document.querySelector('[data-kas-redeem-list]');
                        if (redeemListContainer && window.__kasRedeemRules) {
                            renderRedeemList(redeemListContainer, window.__kasRedeemRules);
                        }
                    }
                }
            }
        }).catch(function(error) {
        });
    }

    // Smooth scrolling for any anchor links
    const links = document.querySelectorAll('a[href^="#"]');
    links.forEach(link => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            if (target) {
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    });

    // Fetch shop rules from DataJet endpoint
    async function fetchShopRules() {
        try {
            const API_ENDPOINT = `https://launcher.api.influence.io/launcher/v1/shop/rules/earn?shop=${SHOP_DOMAIN}`;

            const response = await fetch(API_ENDPOINT, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            // Handle Influence.io API response structure: data.rules
            if (data && data.rules) {
                displayEarnRules(data.rules);
            } else {
                console.error('Unexpected response structure:', data);
                displayFallbackRules();
            }
        } catch (error) {
            // Error fetching shop rules - non-critical
            // Display fallback content if API fails
            displayFallbackRules();
        }
    }

    // Fetch redeem rules from DataJet endpoint
    async function fetchRedeemRules() {
        try {
            const API_ENDPOINT = `https://launcher.api.influence.io/launcher/v1/shop/rules/redeem?shop=${SHOP_DOMAIN}`;

            const response = await fetch(API_ENDPOINT, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            
            // Handle Influence.io API response structure: data.rules
            if (data && data.rules) {
                // Store redeem rules globally for later use
                window.__kasRedeemRules = data.rules;
                updateRedeemProgress(data.rules);
                
                // Update the redeem list display
                const redeemListContainer = document.querySelector('[data-kas-redeem-list]');
                if (redeemListContainer) {
                    renderRedeemList(redeemListContainer, data.rules);
                    
                    // If points are already loaded, re-render the list to update availability
                    if (window.customer?.pointBalance !== null && window.customer?.pointBalance !== undefined) {
                        // Small delay to ensure DOM is ready
                        setTimeout(() => {
                            renderRedeemList(redeemListContainer, data.rules);
                        }, 100);
                    }
                }
            } else {
                console.error('Unexpected redeem rules response structure:', data);
            }
        } catch (error) {
            console.error('Error fetching redeem rules:', error);
        }
    }


    // Display the fetched earning rules
    function displayEarnRules(rules) {
        
        const earnGrid = document.querySelector('.earn-grid');
        if (!earnGrid) {
            // Don't return early - we still need to store the rules for point calculations
        }

        // Clear existing placeholder content (only if earnGrid exists)
        if (earnGrid) {
            earnGrid.innerHTML = '';
        }

        // Store earning rules globally for point calculations
        window.__kasEarnRules = rules;
        
        // Trigger product points update when rules are loaded
        if (typeof updateProductPoints === 'function') {
            const productHelpers = document.querySelectorAll('.swell-product-helper[data-mode="display-points"]');
            productHelpers.forEach(function(helper) {
                updateProductPoints(helper);
            });
        } else {
        }

        // Map template names to icons and descriptions
        const ruleTemplates = {
            'placeorder': { icon: '🛍️', description: 'Earn points with every purchase' },
            'signup': { icon: '✨', description: 'Welcome bonus for joining' },
            'birthday': { icon: '🎂', description: 'Special birthday reward' },
            'review': { icon: '⭐', description: 'Share your feedback' },
            'followinstagram': { icon: '💎', description: 'Follow us on Instagram' },
            'sharefacebook': { icon: '💎', description: 'Share on Facebook' },
            'dynamiclink': { icon: '💎', description: 'Complete this action' },
            'social_follow': { icon: '📱', description: 'Follow us on social media' },
            'referral': { icon: '🎁', description: 'Refer friends and earn' }
        };

        // Group rules by template to avoid duplicates, keeping highest value
        const uniqueRules = {};

        rules.forEach(rule => {
            if (rule.status === 'Active') {
                if (rule.templateName === 'placeorder') {
                    if (!uniqueRules['placeorder'] || rule.earnValue > uniqueRules['placeorder'].earnValue) {
                        uniqueRules['placeorder'] = rule;
                    }
                } else {
                    uniqueRules[rule.templateName] = rule;
                }
            }
        });

        // Convert back to array and create cards
        Object.values(uniqueRules).forEach(rule => {
            const card = document.createElement('div');
            card.className = 'earn-card';

            const template = ruleTemplates[rule.templateName] || { icon: '💎', description: 'Earn rewards' };

            let pointsDisplay = '';
            let description = template.description;

            if (rule.earnType === 'increments') {
                pointsDisplay = `$${rule.earnValue}`;
                description = `Earn ${rule.earnValue} points for every $1 spent`;
            } else {
                pointsDisplay = rule.earnValue.toLocaleString();
                if (rule.templateName === 'signup') {
                    description = `Get ${rule.earnValue.toLocaleString()} points instantly when you join`;
                } else if (rule.templateName === 'birthday') {
                    description = 'Special birthday reward';
                } else if (rule.templateName === 'dynamiclink' && rule.customTitle) {
                    description = rule.customTitle;
                }
            }

            const title = rule.customTitle || rule.title;

            card.innerHTML = `
                <div class="earn-icon">${template.icon}</div>
                <div class="points-badge">${pointsDisplay}</div>
                <h3>${title}</h3>
                <p>${description}</p>
            `;

            if (earnGrid) {
                earnGrid.appendChild(card);
            }
        });

        const signupRule = rules.find(r => r.templateName === 'signup' && r.status === 'Active');
        if (signupRule && earnGrid) {
            const specialCard = document.createElement('div');
            specialCard.className = 'earn-card special';
            specialCard.innerHTML = `
                <div class="earn-icon">🎯</div>
                <h3>${signupRule.earnValue} Point Sign-up Bonus!</h3>
                <p>Join today and get ${signupRule.earnValue} points instantly</p>
            `;
            earnGrid.appendChild(specialCard);
        }
    }

    function displayFallbackRules() {
        const earnGrid = document.querySelector('.earn-grid');
        if (!earnGrid) return;
    }

    // Fetch redeem rules from Influence.io public API
    async function fetchRedeemRules() {
        try {
            const API_URL = `https://launcher.api.influence.io/launcher/v1/shop/rules/redeem?shop=${SHOP_DOMAIN}`;

            const response = await fetch(API_URL, {
                method: 'GET',
                headers: { 'Accept': 'application/json' }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            window.__kasRedeemRules = data.rules;
            displayRedeemRules(data.rules);
            const redeemList = document.querySelector('[data-kas-redeem-list]');
            if(redeemList){ 
                renderRedeemList(redeemList, data.rules);
                
                // If points are already loaded, re-render the list to update availability
                if (window.customer?.pointBalance !== null && window.customer?.pointBalance !== undefined) {
                    // Small delay to ensure DOM is ready
                    setTimeout(() => {
                        renderRedeemList(redeemList, data.rules);
                    }, 100);
                }
            }
        } catch (error) {
            // Error fetching redeem rules - non-critical
            displayFallbackRedeemRules();
        }
    }

    function displayRedeemRules(rules) {
        const redeemGrid = document.getElementById('redeem-rules-grid');
        if (!redeemGrid) return;

        redeemGrid.innerHTML = '';
        rules.sort((a, b) => a.pointCost - b.pointCost);

        const rulesToDisplay = rules.slice(0, 5);
        rulesToDisplay.forEach(rule => {
            if (rule.status === 'Active') {
                const card = document.createElement('div');
                card.className = 'discount-card';
                const discountAmount = `$${rule.discountValue} OFF`;
                const pointsCost = rule.pointCost / 100;
                const pointsRequired = `${pointsCost.toLocaleString()} POINTS`;
                card.innerHTML = `
                    <span class="discount-amount">${discountAmount}</span>
                    <span class="points-required">${pointsRequired}</span>
                `;
                redeemGrid.appendChild(card);
            }
        });

        const currentCards = redeemGrid.children.length;
        if (currentCards < 5) {
            const defaultValues = [
                { discount: 10, points: 100 },
                { discount: 20, points: 200 },
                { discount: 30, points: 300 },
                { discount: 40, points: 400 },
                { discount: 50, points: 500 }
            ];
            for (let i = currentCards; i < 5; i++) {
                const card = document.createElement('div');
                card.className = 'discount-card';
                card.innerHTML = `
                    <span class="discount-amount">$${defaultValues[i].discount} OFF</span>
                    <span class="points-required">${defaultValues[i].points} POINTS</span>
                `;
                redeemGrid.appendChild(card);
            }
        }
    }

    // Fetch loyalty tiers from Influence.io public API
    async function fetchLoyaltyTiers() {
        try {
            const url = `https://launcher.api.influence.io/launcher/v1/shop/tiers?shop=${SHOP_DOMAIN}`;
            const options = { method: 'GET', headers: { accept: 'application/json' } };
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            // Store tiers globally for lookup
            window.__kasLoyaltyTiers = data.rules;
            displayLoyaltyTiers(data.rules);
        } catch (error) {
            // Error fetching loyalty tiers - non-critical
            displayFallbackTiers();
        }
    }

    function displayLoyaltyTiers(tiers) {
        const tiersGrid = document.querySelector('.tiers-grid');
        if (!tiersGrid) return;
        tiersGrid.innerHTML = '';
        tiers.sort((a, b) => a.threshold - b.threshold);
        const tierIcons = { 'Decor Lover': '🏠', 'Style Specialist': '✨', 'Master Designer': '👑' };
        tiers.forEach((tier, index) => {
            const card = document.createElement('div');
            card.className = 'tier-card';
            if (index === 1 && tiers.length === 3) { card.className += ' featured'; }
            const icon = tierIcons[tier.title] || '🎯';
            let pointsRange = '';
            if (tier.threshold === 0) {
                const nextTier = tiers[index + 1];
                pointsRange = nextTier ? `0-${nextTier.threshold - 1} points` : '0+ points';
            } else {
                const nextTier = tiers[index + 1];
                pointsRange = nextTier ? `${tier.threshold}-${nextTier.threshold - 1} points` : `${tier.threshold}+ points`;
            }
            const benefitsHTML = tier.perks.map(perk => `<li>${perk}</li>`).join('');
            card.innerHTML = `
                <div class="tier-icon">${icon}</div>
                <h3>${tier.title}</h3>
                <p class="tier-range">${pointsRange}</p>
                <ul class="tier-benefits">${benefitsHTML}</ul>
            `;
            tiersGrid.appendChild(card);
        });
    }

    function displayFallbackTiers() {
    }

    // Fetch referral rules from Influence.io public API
    async function fetchReferralRules() {
        try {
            const url = `https://launcher.api.influence.io/launcher/v1/shop/rules/referral?shop=${SHOP_DOMAIN}`;
            const options = { method: 'GET', headers: { accept: 'application/json' } };
            const response = await fetch(url, options);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            displayReferralRules(data.rules);
        } catch (error) {
            // Error fetching referral rules - non-critical
        }
    }

    function displayReferralRules(rules) {
        if (!rules || rules.length === 0) return;
        const friendReward = rules.find(r => r.referralType === 'friend' && r.status === 'Active');
        const customerReward = rules.find(r => r.referralType === 'customer' && r.status === 'Active');
        const referHeading = document.querySelector('.refer-text h3');
        if (referHeading && friendReward && customerReward) {
            let friendValue = friendReward.title;
            let customerValue = customerReward.title;
            const friendMatch = friendValue.match(/\$?(\d+)/);
            const friendAmount = friendMatch ? `$${friendMatch[1]}` : friendValue;
            const customerMatch = customerValue.match(/(\d+)\s*[Pp]oints?/);
            const customerPoints = customerMatch ? `${customerMatch[1]} POINTS` : customerValue;
            referHeading.textContent = `GIVE ${friendAmount} OFF, GET ${customerPoints}`;
        }
        const referDescription = document.querySelector('.refer-text p');
        if (referDescription && friendReward && customerReward) {
            const friendMatch = friendReward.title.match(/\$?(\d+)/);
            const friendAmount = friendMatch ? `$${friendMatch[1]}` : friendReward.title;
            const customerMatch = customerReward.title.match(/(\d+)\s*[Pp]oints?/);
            const customerPoints = customerMatch ? customerMatch[1] : '200';
            referDescription.textContent = `Give your friends ${friendAmount} off their first purchase of $120, and get ${customerPoints} points for each successful referral.`;
        }
    }

    // CTA Button interactions
    const ctaButtons = document.querySelectorAll('.cta-button');
    ctaButtons.forEach(button => {
        button.addEventListener('click', function() {
            alert('Redirecting to KAS Rewards signup...');
            if (typeof gtag !== 'undefined') {
                gtag('event', 'click', {
                    'event_category': 'rewards',
                    'event_label': 'join_rewards_program'
                });
            }
        });
    });

    // Add animation on scroll (Intersection Observer)
    const observerOptions = { threshold: 0.1, rootMargin: '0px 0px -50px 0px' };
    const observer = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.style.opacity = '1';
                entry.target.style.transform = 'translateY(0)';
            }
        });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.step, .benefit-card, .tier-card');
    animatedElements.forEach(el => {
        el.style.opacity = '0';
        el.style.transform = 'translateY(30px)';
        el.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
        observer.observe(el);
    });

    const gridContainers = document.querySelectorAll('.steps-grid, .benefits-grid, .tiers-grid');
    gridContainers.forEach(container => {
        const items = container.children;
        Array.from(items).forEach((item, index) => {
            item.style.transitionDelay = `${index * 0.1}s`;
        });
    });

    const tierCards = document.querySelectorAll('.tier-card');
    tierCards.forEach(card => {
        card.addEventListener('mouseenter', function() {
            this.style.transform = 'translateY(-10px) scale(1.02)';
        });
        card.addEventListener('mouseleave', function() {
            this.style.transform = 'translateY(0) scale(1)';
        });
    });

    // Mobile menu toggle (if needed for Shopify integration)
    function toggleMobileMenu() {
        const mobileMenu = document.querySelector('.mobile-menu');
        if (mobileMenu) {
            mobileMenu.classList.toggle('open');
        }
    }

    function trackSectionView(sectionName) {
        if (typeof gtag !== 'undefined') {
            gtag('event', 'page_view', {
                'event_category': 'rewards_page',
                'event_label': sectionName
            });
        }
    }

    const sections = document.querySelectorAll('section');
    const sectionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const sectionClass = entry.target.className;
                trackSectionView(sectionClass);
            }
        });
    }, { threshold: 0.5 });

    sections.forEach(section => {
        sectionObserver.observe(section);
    });

    // Initialize and display customer tier status
    async function initCustomerTierStatus() {
        const isLoggedIn = Boolean(window.customer && window.customer.id);
        if (!isLoggedIn) return;

        try {
            // Wait for both loyalty details and tiers to be available
            const loyaltyDetails = await fetchCustomerLoyaltyDetails();
            
            if (!loyaltyDetails) {
                // Loyalty details endpoint not available, using default tier display
                return;
            }

            // Wait for tiers to be loaded (with timeout)
            let attempts = 0;
            while (!window.__kasLoyaltyTiers && attempts < 50) {
                await new Promise(resolve => setTimeout(resolve, 100));
                attempts++;
            }

            if (!window.__kasLoyaltyTiers) {
                // Tiers not loaded, skipping tier status update
                return;
            }

            updateTierStatusUI(loyaltyDetails, window.__kasLoyaltyTiers);
        } catch (error) {
            // Error initializing tier status (non-critical)
        }
    }

    // Update tier status UI with customer data
    function updateTierStatusUI(loyaltyDetails, tiers) {
        const currentTierNameEl = document.querySelector('[data-kas-current-tier-name]');
        const nextTierNameEl = document.querySelector('[data-kas-next-tier-name]');
        const nextTierThresholdEl = document.querySelector('[data-kas-next-tier-threshold]');
        const currentSpendEl = document.querySelector('[data-kas-current-spend]');
        const nextTierSpendEl = document.querySelector('[data-kas-next-tier-spend]');
        const progressFillEl = document.querySelector('[data-kas-tier-progress-fill]');
        const progressMarkerEl = document.querySelector('[data-kas-tier-progress-marker]');

        // Get current tier name
        const currentTierName = loyaltyDetails.currentLoyaltyTierName || 'Decor Lover';
        
        // Find current tier in tiers array
        const sortedTiers = tiers.sort((a, b) => a.threshold - b.threshold);
        const currentTierIndex = sortedTiers.findIndex(t => t.id === loyaltyDetails.currentLoyaltyTierId);
        const currentTier = sortedTiers[currentTierIndex];
        const nextTier = sortedTiers[currentTierIndex + 1];

        // Update current tier name
        if (currentTierNameEl) {
            currentTierNameEl.textContent = currentTierName;
        }

        // Highlight the current tier card
        const allTierCards = document.querySelectorAll('[data-tier-name]');
        allTierCards.forEach(card => {
            card.classList.remove('current-tier');
            if (card.getAttribute('data-tier-name') === currentTierName) {
                card.classList.add('current-tier');
            }
        });

        // Update next tier information if there is one
        if (nextTier) {
            if (nextTierNameEl) {
                nextTierNameEl.textContent = nextTier.title;
            }

            // Calculate spending needed
            const currentSpend = loyaltyDetails.currentLoyaltyTierProgress || 0;
            const nextTierThreshold = nextTier.threshold || 0;
            const spendNeeded = Math.max(0, nextTierThreshold - currentSpend);

            if (nextTierThresholdEl) {
                nextTierThresholdEl.textContent = `$${spendNeeded}`;
            }

            if (currentSpendEl) {
                currentSpendEl.textContent = `$${currentSpend} Spent`;
            }

            if (nextTierSpendEl) {
                nextTierSpendEl.textContent = `Spend $${nextTierThreshold}`;
            }

            // Update progress bar
            const progressPercent = nextTierThreshold > 0 
                ? Math.min(100, (currentSpend / nextTierThreshold) * 100) 
                : 0;

            if (progressFillEl) {
                progressFillEl.style.width = `${progressPercent}%`;
            }

            if (progressMarkerEl) {
                progressMarkerEl.style.left = `${progressPercent}%`;
            }
        } else {
            // Max tier reached
            if (nextTierNameEl) {
                nextTierNameEl.textContent = 'Max Tier';
            }
            if (nextTierThresholdEl && nextTierThresholdEl.parentElement) {
                nextTierThresholdEl.parentElement.textContent = 'You have reached the highest tier!';
            }
        }
    }

    // Initialize product points display
    function initProductPointsDisplay() {
        const productHelpers = document.querySelectorAll('.swell-product-helper[data-mode="display-points"]');
        
        if (productHelpers.length === 0) {
            return;
        }
        
        productHelpers.forEach(function(helper) {
            updateProductPoints(helper);
        });
    }

    // Call initProductPointsDisplay immediately
    initProductPointsDisplay();

});

// Update redeem progress in the drawer widget (global function)
function updateRedeemProgress(redeemRules) {
    
    // Get current user points
    const currentPoints = window.customer?.pointBalance || null;
    
    // Filter active fixed amount discounts
    const activeFixedDiscounts = redeemRules.filter(rule => 
        rule.status === 'Active' && 
        rule.templateName === 'amountdiscount' && 
        rule.redeemType === 'fixed'
    );
    
    
    // Handle null points
    if (currentPoints === null) {
        const progressText = document.querySelector('[data-kas-rewards-missing]');
        if (progressText) {
            progressText.textContent = 'Points unavailable';
        }
        return;
    }
    
    // Find the nearest discount the user can't afford yet
    const affordableDiscounts = activeFixedDiscounts.filter(rule => 
        currentPoints >= rule.pointCost
    );
    
    const unaffordableDiscounts = activeFixedDiscounts.filter(rule => 
        currentPoints < rule.pointCost
    );
    
    
    let targetDiscount = null;
    let pointsNeeded = 0;
    
    if (unaffordableDiscounts.length > 0) {
        // Find the cheapest unaffordable discount
        targetDiscount = unaffordableDiscounts.reduce((cheapest, current) => 
            current.pointCost < cheapest.pointCost ? current : cheapest
        );
        pointsNeeded = targetDiscount.pointCost - currentPoints;
    } else if (affordableDiscounts.length > 0) {
        // User can afford at least one discount, find the most expensive one they can't afford
        const sortedUnaffordable = activeFixedDiscounts
            .filter(rule => currentPoints < rule.pointCost)
            .sort((a, b) => a.pointCost - b.pointCost);
        
        if (sortedUnaffordable.length > 0) {
            targetDiscount = sortedUnaffordable[0];
            pointsNeeded = targetDiscount.pointCost - currentPoints;
        }
    }
    
    
    // Update the drawer widget text
    const progressText = document.querySelector('[data-kas-rewards-missing]');
    if (progressText && targetDiscount) {
        progressText.textContent = `⚡ You're ${pointsNeeded} points away from ${targetDiscount.title}!`;
    } else if (progressText) {
        // Fallback if no target discount found
        progressText.textContent = 'You have enough points for rewards!';
    }
}

// Calculate points earned for a given price (global function)
function calculatePointsForPrice(priceCents) {
    
    if (!window.__kasEarnRules) {
        console.warn('Earning rules not loaded yet');
        return 0;
    }

    // Get customer's current loyalty tier ID
    const customerTierId = window.customer?.currentLoyaltyTierId;

    // Find the active placeorder rule that matches the customer's tier
    let placeorderRule = window.__kasEarnRules.find(rule => 
        rule.templateName === 'placeorder' && 
        rule.status === 'Active' &&
        rule.loyaltyTierIds && 
        rule.loyaltyTierIds.includes(customerTierId)
    );


    // If no tier-specific rule found, try to find a general placeorder rule
    if (!placeorderRule) {
        placeorderRule = window.__kasEarnRules.find(rule => 
            rule.templateName === 'placeorder' && 
            rule.status === 'Active' &&
            (!rule.loyaltyTierIds || rule.loyaltyTierIds.length === 0)
        );
    }

    if (!placeorderRule) {
        console.warn('No active placeorder rule found');
        return 0;
    }

    // Calculate points: price / earnValue = points earned
    const priceDollars = priceCents / 100;
    const points = Math.floor(priceDollars / placeorderRule.earnValue);
    return points;
}

// Update individual product points display (global function)
function updateProductPoints(helper) {
    const priceCents = parseInt(helper.getAttribute('data-price-cents'));
    
    const pointsEarned = calculatePointsForPrice(priceCents);
    
    if (pointsEarned > 0) {
        helper.textContent = pointsEarned + ' points';
        helper.setAttribute('data-points-earned', pointsEarned);
    } else {
        // If earning rules not loaded yet, set up retry mechanism
        let retryCount = 0;
        const maxRetries = 10;
        const retryInterval = 1000; // 1 second
        
        const retryFunction = function() {
            retryCount++;
            const retryPoints = calculatePointsForPrice(priceCents);
            
            if (retryPoints > 0) {
                helper.textContent = retryPoints + ' points';
                helper.setAttribute('data-points-earned', retryPoints);
            } else if (retryCount < maxRetries) {
                setTimeout(retryFunction, retryInterval);
            } else {
                // Fallback: show default message
                helper.textContent = 'points';
            }
        };
        
        setTimeout(retryFunction, retryInterval);
    }
}
function initRewardsBanner(){
    const banner = document.querySelector('[data-kas-rewards-banner]');
    const drawer = document.querySelector('[data-kas-rewards-drawer]');
    const closeBtn = document.querySelector('[data-kas-rewards-close]');
    const loggedInWrap = document.querySelector('[data-kas-rewards-logged-in]');
    const loggedOutWrap = document.querySelector('[data-kas-rewards-logged-out]');
    const bannerMsg = document.querySelector('[data-kas-rewards-banner-msg]');
    const bannerPointsBlock = document.querySelector('[data-kas-rewards-banner-points]');
    const pointsApiUrl = LOYALTY_ENDPOINT;
    
    
    if(!banner || !drawer) {
        return;
    }

    const pointsEls = {
        banner: document.querySelector('[data-kas-rewards-points-banner]'),
        drawer: document.querySelector('[data-kas-rewards-points]'),
        missing: document.querySelector('[data-kas-rewards-missing]')
    };

    // Update points from customer object if available
    function updatePointsUI(points){
        const pointsValue = points === null || points === undefined ? null : Number(points);
        
        
        // Update customer object with current points
        if (window.customer) {
            window.customer.pointBalance = pointsValue;
        }
        
        // Update banner display
        if(pointsEls.banner) {
            const displayValue = pointsValue === null ? '-' : pointsValue;
            pointsEls.banner.textContent = displayValue;
        }
        
        // Update drawer display
        if(pointsEls.drawer) {
            const displayValue = pointsValue === null ? '-' : pointsValue;
            pointsEls.drawer.textContent = displayValue;
        }
        
        // Update account page points display (same selector as drawer, but ensure it's updated)
        const accountPointsEl = document.querySelector('[data-kas-rewards-points]');
        if(accountPointsEl) {
            const displayValue = pointsValue === null ? '0' : pointsValue;
            accountPointsEl.textContent = displayValue;
        }
        
        // Update progress message
        if(pointsEls.missing){
            // This will be updated by updateRedeemProgress when redeem rules are loaded
            pointsEls.missing.textContent = '';
        }
        
        // Also update swell point balance elements
        const swellPointBalances = document.querySelectorAll('.swell-point-balance');
        swellPointBalances.forEach(function(element) {
            if (pointsValue === null) {
                element.textContent = '-';
            } else {
                element.textContent = pointsValue + ' points';
            }
        });
        
        // Trigger redeem progress update if redeem rules are available
        if (window.__kasRedeemRules) {
            updateRedeemProgress(window.__kasRedeemRules);
            
            // Also re-render the redeem list with updated points
            const redeemListContainer = document.querySelector('[data-kas-redeem-list]');
            if (redeemListContainer) {
                renderRedeemList(redeemListContainer, window.__kasRedeemRules);
            }
        } else {
        }
    }

    // Example: read from a metafield or placeholder; using null when unknown
    const isLoggedIn = Boolean(window.customer && window.customer.id);
    let currentPoints = null;

    // Fetch points from DataJet API (same as account.js)
    async function fetchUserPoints(retryCount = 0) {
        const maxRetries = 2;
        const retryDelay = 2000;
        
        
        if (!isLoggedIn || !LOYALTY_ENDPOINT || !window.customer?.email || !window.customer?.id) {
            return null;
        }
        
        try {
            
            // Use direct API call (after CORS headers are added to data.kasaustralia.com.au)
            const apiUrl = `${LOYALTY_ENDPOINT}?email=${encodeURIComponent(window.customer.email)}&customer_id=${encodeURIComponent(window.customer.id)}`;
            
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    'Accept': 'application/json'
                }
            });
            
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
            }
            
            const data = await response.json();
            
            // Extract points from direct API response structure
            if (data && data.pointBalance !== undefined) {
                return data.pointBalance || 0;
            }
            
            return null;
            
        } catch (error) {
            // Error fetching user points from direct API
            
            // Retry logic for network errors
            if (retryCount < maxRetries && (
                error.message.includes('Failed to fetch') || 
                error.message.includes('timeout') ||
                error.message.includes('NetworkError') ||
                error.message.includes('Request timeout') ||
                error.message.includes('HTTP error! status: 0') ||
                error.message.includes('HTTP error! status: 5') ||
                error.message.includes('Network error')
            )) {
                await new Promise(resolve => setTimeout(resolve, retryDelay * (retryCount + 1)));
                return fetchUserPoints(retryCount + 1);
            }
            
            return null;
        }
    }

    // Initialize points and UI
    async function initializePoints() {
        if (isLoggedIn) {
            try {
                currentPoints = await fetchUserPoints();
                
                // Store successful API response for caching
                if (currentPoints !== null && currentPoints > 0) {
                    localStorage.setItem('kas_user_points', currentPoints.toString());
                }
            } catch (error) {
                
                // Try to get points from localStorage as fallback
                const storedPoints = localStorage.getItem('kas_user_points');
                if (storedPoints) {
                    currentPoints = parseInt(storedPoints, 10);
                } else {
                    // If no cached points and API is failing, show dash
                    currentPoints = null;
                    
                    // Show a user-friendly message in the UI
                    const pointsDisplay = document.querySelector('[data-kas-rewards-points]');
                    if (pointsDisplay) {
                        pointsDisplay.textContent = '-';
                    }
                    
                    // Also update the banner points display
                    const bannerPointsDisplay = document.querySelector('[data-kas-rewards-points-banner]');
                    if (bannerPointsDisplay) {
                        bannerPointsDisplay.textContent = '-';
                    }
                }
            }
        } else {
            currentPoints = null;
        }
        updatePointsUI(currentPoints);
    }

    // Wait for customer data to be available
    function waitForCustomerData() {
        return new Promise((resolve) => {
            if (window.customer && window.customer.id && window.customer.email) {
                resolve();
                return;
            }
            
            // Check every 100ms for up to 5 seconds
            let attempts = 0;
            const checkInterval = setInterval(() => {
                attempts++;
                if (window.customer && window.customer.id && window.customer.email) {
                    clearInterval(checkInterval);
                    resolve();
                } else if (attempts > 50) { // 5 seconds
                    clearInterval(checkInterval);
                    resolve();
                }
            }, 100);
        });
    }

    // Switch UI per login state
    
    if(isLoggedIn){
        if(loggedInWrap) loggedInWrap.hidden = false;
        if(loggedOutWrap) loggedOutWrap.hidden = true;
        if(bannerMsg) bannerMsg.hidden = true;
        if(bannerPointsBlock) bannerPointsBlock.hidden = false;
        const nameEl = document.querySelector('[data-kas-rewards-name]');
        if(nameEl && window.customer.firstName){ nameEl.textContent = window.customer.firstName; }
        
        // Wait for customer data then fetch points
        waitForCustomerData().then(() => {
            initializePoints();
        });
    } else {
        if(loggedInWrap) {
            loggedInWrap.hidden = true;
        }
        if(loggedOutWrap) {
            loggedOutWrap.hidden = false;
        }
        if(bannerMsg) {
            bannerMsg.hidden = false;
        }
        if(bannerPointsBlock) {
            bannerPointsBlock.hidden = true;
        }
        
        // Force hide the points block with additional methods
        const pointsBlock = document.querySelector('[data-kas-rewards-banner-points]');
        if (pointsBlock) {
            pointsBlock.style.display = 'none';
            pointsBlock.hidden = true;
        }
        
        // Also ensure the banner message is visible
        const bannerMessage = document.querySelector('[data-kas-rewards-banner-msg]');
        if (bannerMessage) {
            bannerMessage.style.display = 'block';
            bannerMessage.hidden = false;
        }
    }

    // Toggle
    function openDrawer(){
        drawer.setAttribute('aria-hidden','false');
        banner.setAttribute('aria-expanded','true');
        
        // Add open class and force transform with multiple methods
        drawer.classList.add('open');
        drawer.classList.remove('closed');
        drawer.style.transform = 'translateY(0) !important';
        drawer.style.setProperty('transform', 'translateY(0)', 'important');
        
        
        // Force the transform to be correct with multiple attempts
        setTimeout(() => {
            drawer.style.setProperty('transform', 'translateY(0)', 'important');
        }, 50);
        
        setTimeout(() => {
            drawer.style.setProperty('transform', 'translateY(0)', 'important');
        }, 100);
    }
    function closeDrawer(){
        drawer.setAttribute('aria-hidden','true');
        banner.setAttribute('aria-expanded','false');
        
        // Remove open class and reset transform
        drawer.classList.remove('open');
        drawer.classList.add('closed');
        drawer.style.setProperty('transform', 'translateY(100%)', 'important');
    }
    banner.addEventListener('click', function(){
        const expanded = banner.getAttribute('aria-expanded') === 'true';
        expanded ? closeDrawer() : openDrawer();
    });
    if(closeBtn){ 
        closeBtn.addEventListener('click', closeDrawer); 
    } else {
    }

    // Populate redeem list if API already fetched
    const redeemList = document.querySelector('[data-kas-redeem-list]');
    if(redeemList && window.__kasRedeemRules){
        renderRedeemList(redeemList, window.__kasRedeemRules);
    }

    // Manual points refresh function
    async function refreshPointsManually() {
        try {
            const newPoints = await fetchUserPoints();
            if (newPoints > 0) {
                currentPoints = newPoints;
                localStorage.setItem('kas_user_points', newPoints.toString());
                updatePointsUI(currentPoints);
                return true;
            } else {
                return false;
            }
        } catch (error) {
            // Manual refresh failed
            return false;
        }
    }


    // Expose updater so other parts can set points
    window.KASRewards = window.KASRewards || {};
    window.KASRewards.updateBannerPoints = updatePointsUI;
    window.KASRewards.refreshPoints = initializePoints;
    window.KASRewards.refreshPointsManually = refreshPointsManually;
    window.KASRewards.fetchCustomerLoyaltyDetails = fetchCustomerLoyaltyDetails;
    window.KASRewards.getLoyaltyTierName = getLoyaltyTierName;
    window.KASRewards.updatePoints = updatePointsUI;
    window.KASRewards.calculatePointsForPrice = calculatePointsForPrice;
    window.KASRewards.updateRedeemProgress = updateRedeemProgress;
}

// Helper function to get tier name by tier ID
function getLoyaltyTierName(tierId) {
    if (!tierId) return null;
    
    // Check if tiers are loaded
    if (window.__kasLoyaltyTiers && Array.isArray(window.__kasLoyaltyTiers)) {
        const tier = window.__kasLoyaltyTiers.find(t => t.id === tierId);
        return tier ? tier.title : null;
    }
    
    return null;
}

// Fetch customer loyalty details from DataJet API
async function fetchCustomerLoyaltyDetails(retryCount = 0) {
    const maxRetries = 2;
    const retryDelay = 2000;
    
    const isLoggedIn = Boolean(window.customer && window.customer.id);
    
    if (!isLoggedIn || !LOYALTY_DETAILS_ENDPOINT || !window.customer?.email || !window.customer?.id) {
        // Cannot fetch loyalty details: missing customer data or endpoint
        return null;
    }
    
    try {
        // Use direct API call (after CORS headers are added to data.kasaustralia.com.au)
        const apiUrl = `${LOYALTY_DETAILS_ENDPOINT}?email=${encodeURIComponent(window.customer.email)}&customer_id=${encodeURIComponent(window.customer.id)}`;
        
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Accept': 'application/json'
            }
        });
        
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
        }
        
        const data = await response.json();
        
        // Extract customer details from direct API response structure
        if (data && data !== null) {
            // Add the tier name based on currentLoyaltyTierId
            if (data.currentLoyaltyTierId) {
                data.currentLoyaltyTierName = getLoyaltyTierName(data.currentLoyaltyTierId);
            }
            
            // Cache the successful response
            try {
                localStorage.setItem('kas_customer_loyalty_details', JSON.stringify(data));
                localStorage.setItem('kas_customer_loyalty_details_timestamp', Date.now().toString());
            } catch (e) {
                // Could not cache loyalty details
            }
            
            return data;
        }
        
        return null;
        
    } catch (error) {
        // Only log detailed error on first attempt, and only for non-404 errors
        if (retryCount === 0) {
            if (error.message.includes('404')) {
                // Customer details endpoint not found (404). Feature will be disabled.
            } else {
                // Error fetching customer loyalty details from direct API
            }
        }
        
        // Retry logic for network errors (but not 404s)
        if (retryCount < maxRetries && !error.message.includes('404') && (
            error.message.includes('Failed to fetch') || 
            error.message.includes('timeout') ||
            error.message.includes('NetworkError') ||
            error.message.includes('Request timeout') ||
            error.message.includes('HTTP error! status: 0') ||
            error.message.includes('HTTP error! status: 5') ||
            error.message.includes('Network error')
        )) {
            await new Promise(resolve => setTimeout(resolve, retryDelay * (retryCount + 1)));
            return fetchCustomerLoyaltyDetails(retryCount + 1);
        }
        
        // Try to get cached data as fallback
        try {
            const cached = localStorage.getItem('kas_customer_loyalty_details');
            const cacheTimestamp = localStorage.getItem('kas_customer_loyalty_details_timestamp');
            
            if (cached && cacheTimestamp) {
                const age = Date.now() - parseInt(cacheTimestamp, 10);
                // Use cache if less than 1 hour old
                if (age < 3600000) {
                    // Using cached loyalty details as fallback
                    const cachedDetails = JSON.parse(cached);
                    // Try to add tier name if not already present
                    if (cachedDetails.currentLoyaltyTierId && !cachedDetails.currentLoyaltyTierName) {
                        cachedDetails.currentLoyaltyTierName = getLoyaltyTierName(cachedDetails.currentLoyaltyTierId);
                    }
                    return cachedDetails;
                }
            }
        } catch (e) {
            // Could not retrieve cached loyalty details
        }
        
        return null;
    }
}

function renderRedeemList(container, rules){
    container.innerHTML = '';
    
    // Get current user points
    const currentPoints = window.customer?.pointBalance || null;
    
    
    // Sort rules by point cost (lowest to highest) and take first 5
    const sortedRules = rules
      .filter(rule => rule.status === 'Active' && rule.templateName === 'amountdiscount')
      .sort((a, b) => a.pointCost - b.pointCost)
      .slice(0, 5);
    
    
    sortedRules.forEach(rule => {
        const card = document.createElement('div');
        const isRedeemable = currentPoints !== null && currentPoints >= rule.pointCost;
        
        // Add classes based on redeemability
        card.className = isRedeemable ? 'kas-redeem-card redeemable' : 'kas-redeem-card';
        
        // Check if user has enough points for this discount
        const statusText = currentPoints === null ? 'Points unavailable' : (isRedeemable ? 'Redeem Now' : 'Not enough points');
        
        
        card.innerHTML = `
          <div class="kas-redeem-title">$${rule.discountValue} Off</div>
          <div class="kas-redeem-points">${rule.pointCost.toLocaleString()} points</div>
          <div class="kas-redeem-note ${isRedeemable ? 'redeemable' : ''}">${statusText}</div>
        `;
        
        // Add click functionality for redeemable cards
        if (isRedeemable) {
            card.addEventListener('click', function() {
                window.location.href = '/checkout';
            });
        }
        
        container.appendChild(card);
    });
}

// Shopify-specific functions
window.KASRewards = window.KASRewards || {};
Object.assign(window.KASRewards, {
    initializeCustomer: function(customer) {
        if (customer && customer.id) {
            this.updateUIForLoggedInCustomer(customer);
        } else {
            this.updateUIForGuest();
        }
    },
    updateUIForLoggedInCustomer: function(customer) {
        const ctaButtons = document.querySelectorAll('.cta-button');
        ctaButtons.forEach(button => {
            button.textContent = 'View My Rewards';
            button.onclick = function() { window.location.href = '/account'; };
        });
    },
    updateUIForGuest: function() {
        const ctaButtons = document.querySelectorAll('.cta-button');
        ctaButtons.forEach(button => {
            button.onclick = function() { window.location.href = '/account/register'; };
        });
    },
    updatePointsDisplay: function(points) {
        const pointsDisplay = document.querySelector('.points-display');
        if (pointsDisplay) { pointsDisplay.textContent = `${points} points`; }
    },
    // Get customer loyalty details including tier info, referral link, etc.
    getCustomerLoyaltyDetails: async function() {
        if (typeof fetchCustomerLoyaltyDetails === 'function') {
            return await fetchCustomerLoyaltyDetails();
        }
        return null;
    }
});

// Initialize when Shopify customer data is available
document.addEventListener('shopify:section:load', function() {
    if (typeof window.customer !== 'undefined') {
        window.KASRewards.initializeCustomer(window.customer);
    }
});

// Refer a Friend Form Handler
document.addEventListener('DOMContentLoaded', function() {
    const referForm = document.getElementById('referFriendForm');
    if (referForm) {
        referForm.addEventListener('submit', function(e) {
            e.preventDefault();
            const email = document.getElementById('friendEmail').value;
            alert(`Referral sent to ${email}! They'll receive $20 off their first order.`);
            referForm.reset();
        });
    }
});

// Copy referral link function
window.copyReferralLink = function() {
    const urlInput = document.querySelector('.share-url');
    if (urlInput) {
        urlInput.select();
        urlInput.setSelectionRange(0, 99999);
        try {
            document.execCommand('copy');
            const copyBtn = document.querySelector('.copy-btn');
            const originalHTML = copyBtn.innerHTML;
            copyBtn.textContent = 'Copied!';
            setTimeout(() => { copyBtn.innerHTML = originalHTML; }, 2000);
        } catch (err) {
            // Failed to copy text
        }
    }
};

// Share on WhatsApp function
window.shareOnWhatsApp = function() {
    const referralUrl = document.querySelector('.share-url').value;
    const message = `Check out KAS Australia! Get $20 off your first order of $120 or more: ${referralUrl}`;
    const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
};
